<template>
  <article id="policy-details-deductible" data-test-policy-deductible-section>
    <h2 data-test-policy-deductible-label>
      {{ modelValue.LabelDeductibleHeadline }}
    </h2>

    <field
      v-model="modelValue.Deductible"
      name="policy-deductible"
      data-test-policy-deductible-amount
    />

    <info-box
      v-if="modelValue.Deductible.ShowFieldMessage && !showManualDeductibleMessage"
      :text="modelValue.Deductible.FieldMessage"
      :arrow-show="false"
      :info-box-class="infoBoxClass"
    />

    <info-box
      v-if="showManualDeductibleMessage"
      :arrow-show="false"
      :text="modelValue.InfoText"
      info-box-class="info-box-negative-top-margin"
    />
  </article>
</template>

<script>
import Field from './Field.vue';
import InfoBox from '@/components/UI/InfoBox.vue';

export default {
  name: 'Deductible',
  components: {
    Field,
    InfoBox
  },
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    editMode() {
      return this.$store.state.policy.editMode;
    },
    infoBoxClass() {
      const infoBoxWarningClass = this.modelValue.Deductible.ShowFieldMessageWarningIcon
        ? ' info-box-warning'
        : '';
      return 'info-box-negative-top-margin' + infoBoxWarningClass;
    },
    showManualDeductibleMessage() {
      return this.editMode && this.modelValue.ShowManualDeductibleMessage;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.info-box-negative-top-margin {
  margin-top: rem-calc(5);
}
</style>
